module.exports = __webpack_public_path__ + "img/13_no.d3836b0a.svg";